import { types } from 'mobx-state-tree'
import {
  ScriptFormatPayload,
  ScriptFormatSummary,
} from '@util/ScriptoApiClient/types'

export const ScriptFormatSummaryModel = types.frozen<ScriptFormatSummary>()
export const ScriptFormatModel = types.frozen<ScriptFormatPayload>()
